import { useState } from "react";

/** Deterministic hue (0–359) from a string, so a given person always gets the same monogram colour. */
function hueOf(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) % 360;
  return h;
}

function initialsOf(label: string): string {
  const parts = label.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  const chars = parts.length === 1 ? parts[0].slice(0, 2) : parts[0][0] + parts[parts.length - 1][0];
  return chars.toUpperCase();
}

/**
 * A person's avatar: their image when available, otherwise an initials monogram in a colour derived
 * from their name/email (stable per person). Falls back to the monogram if the image fails to load,
 * so a broken/removed photo never shows a broken-image icon.
 */
export function Avatar({
  name,
  email,
  src,
  size = 32,
}: {
  name?: string | null;
  email?: string | null;
  src?: string | null;
  size?: number;
}) {
  const [broken, setBroken] = useState(false);
  const label = (name || email || "?").trim();

  if (src && !broken) {
    return (
      <img
        className="avatar avatar-img"
        src={src}
        alt=""
        width={size}
        height={size}
        style={{ width: size, height: size }}
        onError={() => setBroken(true)}
      />
    );
  }

  const hue = hueOf(label);
  return (
    <span
      className="avatar avatar-mono"
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.4),
        background: `hsl(${hue} 42% 82%)`,
        color: `hsl(${hue} 45% 26%)`,
      }}
    >
      {initialsOf(label)}
    </span>
  );
}
